"use client";

import ModelShowcaseScroll from "./ModelShowcaseScroll";
import { useTranslation } from "react-i18next";

interface LandingPageClientProps {
  locale: string;
  defaultModelSegment?: string | null;
}

const LandingPageClient: React.FC<LandingPageClientProps> = ({ locale }) => {
  const { t } = useTranslation("pages");
  const headingText =
    (t("pages:landing.seo.title", { defaultValue: "" }) as string) ||
    (t("pages:landing.hero.title", { defaultValue: "IARTStudio" }) as string);

  return (
    <>
      <h1 className="sr-only">{headingText}</h1>
      <ModelShowcaseScroll locale={locale} />
    </>
  );
};

export default LandingPageClient;
